import styled from "styled-components";

import { LoadingOutlined } from "@ant-design/icons";
import { Form as Unform } from "@unform/web";

export const PaymentContainer = styled.section`
  display: flex;
  align-items: flex-start;
  justify-content: center;

  width: 100%;
  padding: 1.5rem;
  max-width: 43.75rem;

  border-radius: 1rem;
  background: ${({ theme }) => theme?.checkoutStepsOffers?.cardBackground2};
  box-shadow: 0px 0px 3rem rgba(0, 0, 0, 0.09);

  @media (max-width: 375px) {
    padding: 0;
    background: none;
  }
`;

export const PaymentMobileContainer = styled.section`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;

  width: 100%;
  padding: 1.5rem;
  margin: 1.5rem 0 0;
  max-width: 43.75rem;

  border-radius: 1rem;
  background: ${({ theme }) => theme?.checkoutStepsOffers?.cardBackground2};
  box-shadow: 0px 0px 3rem rgba(0, 0, 0, 0.09);

  @media (max-width: 375px) {
    padding: 0;
    background: none;
  }
`;

export const SectionTitle = styled.h1`
  width: 100%;
  padding: 0 0 1rem;

  font-family: Inter;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.688rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
  border-bottom: 0.063rem solid
    ${({ theme }) => theme.checkoutStepsOffers?.widgetBackground};
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 2rem;

  width: 100%;

  .address-container,
  .installments-container {
    margin: 1.5rem 0 0;
  }
`;

export const Form = styled(Unform)`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

export const CreditCardAlert = styled.p`
  width: 100%;
  margin: 0.75rem 0 0;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5rem;
  text-align: center;
  color: ${({ theme }) => theme.checkoutStepsOffers?.widgetTextColor};
`;

export const ChargeName = styled.strong`
  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};

  font-family: Inter;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
`;

export const LoadingIcon = styled(LoadingOutlined)`
  margin: 0 1rem 0 0;
`;
